import 'css-chunksrc/client/scenes/constrainElement/constrainedElement/element/milestone/styles.scss';export default {
  "milestone": "_milestone_8ef21_1",
  "iconBox": "_iconBox_8ef21_11",
  "icon": "_icon_8ef21_11"
};